import React from 'react';
import { Alert } from 'reactstrap';
import styles from './index.module.scss';
import { AlertProps } from './types';

const { dangerAlert } = styles;

export const AlertDanger = (props: AlertProps) => <Alert data-testid={props.testId} color='danger' className={dangerAlert}>{props.children}</Alert>;
